import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import "./loginIcon.css";

const LoginIcon = () => {
  return <FontAwesomeIcon icon={faSignInAlt} />;
};

export default LoginIcon;
